import { Modals } from 'presentation/libs/modals'

const MODAL_KEY = 'PropertyMarkerTrainingModal'

export const usePropertyMarkerTrainingModal = Modals.createHistoryUseModal(MODAL_KEY)
